import {
  Box,
  FormControlLabel,
  IconButton,
  Radio,
  Slider,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import Title from "../../Add/title";
import CloseIcon from "@mui/icons-material/Close";
import Files from "react-files";
import {CgColorPicker} from "react-icons/cg";
import {Label} from "@mui/icons-material";

const LogoSelect = ({
  formData,
  setFormData,
  uploadOption,
  setUploadOption,
  logoName,
  setLogoName,
  selectedFont,
  setSelectedFont,
  selectedColor,
  setSelectedColor,
  setSelectedBgColor,
  selectedBgColor,
  fontSize,
  setFontSize,
}) => {
  const isPortable = useMediaQuery({ query: "(max-width:1200px)" });
  const [image, setImage] = useState(formData?.logo);


  const fonts = ["Mockads", "Arial", "Great Vibes"];
  const colors = ["#FFFFFF", "#303030", "#ECA601"];

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      const previewUrl = URL.createObjectURL(files[0]);
      setImage(previewUrl)
      setFormData((prev) => ({ ...prev, logo: files[0] }));
    }
  };

  const handleFontChange = (font) => {
    setSelectedFont(font);
  };

  const handleColorClick = (color) => {
    setSelectedColor(color);
  };

  const handleFontSizeChange = (event, newValue) => {
    setFontSize(newValue);
  };

  const handleUploadOptionChange = (option) => {
    setUploadOption(option);
    if (option === "customLogo") {
      setFormData((prev) => ({ ...prev, customLogo: "" }));
    } else {
      setFormData((prev) => ({ ...prev, logo: null }));
    }
  };

  const toggleUploadOption = () => {
    if (uploadOption === "logo") {
      handleUploadOptionChange("customLogo");
    } else {
      handleUploadOptionChange("logo");
    }
  };

  return (
    <div className="logo-container">
      <Title title="Logo Image *" />
      <div className="switcher">
        <FormControlLabel
          control={
            <Switch
              checked={uploadOption === "customLogo"}
              onChange={toggleUploadOption}
              name="uploadOptionSwitch"
            />
          }
          label={
            uploadOption === "logo"
              ? "Switch to Custom Logo"
              : "Switch to Photo Upload"
          }
        />
      </div>
      <Box className="main-styles-container">
        <label>Logo Background</label>
        <TextField
            fullWidth
            type="color"
            variant="outlined"
            value={selectedBgColor}
            onChange={(e) => setSelectedBgColor(e.target.value)}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
        />
      </Box>
      <div className="logo-ways-container">
        {((isPortable && uploadOption === "logo") || !isPortable) && (
          <Box
            sx={{
              width: "100%",
              opacity: uploadOption === "customLogo" ? 0.5 : 1,
              pointerEvents: uploadOption === "customLogo" ? "none" : "auto",
            }}
          >
            <div
              className="custom-logo"
              style={{
                cursor:
                  uploadOption === "customLogo" ? "not-allowed" : "pointer",
              }}
            >
              <Files
                onChange={(fileList) => handleFileChange(fileList)}
                onError={(error) => console.error("File upload error:", error)}
                accepts={["image/*"]}
                clickable
                multiple={false}
                maxFileSize={10485760} // 10MB limit
                disabled={uploadOption === "customLogo"}
                className="files"
              />
              {image ? (
                <div className="selected-logo-container">
                  <img
                    src={image}
                    alt="Uploaded Logo"
                    className="selected-logo-img"
                  />
                  <IconButton
                    onClick={() => {
                      setFormData((prev) => ({ ...prev, logo: null }));
                      setImage(null)
                    }}
                    className="selected-logo-remove"
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  Click to upload a logo
                </Typography>
              )}
            </div>
          </Box>
        )}
        {((isPortable && uploadOption === "customLogo") || !isPortable) && (
          <div
            style={{
              opacity: uploadOption === "logo" ? 0.5 : 1,
              pointerEvents: uploadOption === "logo" ? "none" : "auto",
              cursor: uploadOption === "logo" ? "not-allowed" : "auto",
            }}
            className="logo"
          >
            <div className="main-title">
              <Title title="Create your logo" />
            </div>

            <Box className="main-logo-container">
              <Box className="main-styles-container">
                <TextField
                  fullWidth
                  variant="outlined"
                  value={logoName}
                  onChange={(e) => setLogoName(e.target.value)}
                  placeholder="Type Your Logo Name here"
                  size="small"
                />
                <Box className="title-container">
                  <Typography>Choose a Font:</Typography>
                  <Box className="font-chooses-container">
                    {fonts.map((font) => (
                      <Box key={font} className="font-style-container">
                        <Typography
                          className="font-style"
                          sx={{
                            fontFamily: font,
                          }}
                        >
                          lorem
                        </Typography>
                        <Radio
                          checked={selectedFont === font}
                          onChange={() => handleFontChange(font)}
                          sx={{
                            color: "primary.main",
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>
                <Typography className="text-start">
                  Choose a color and font size:
                </Typography>
                <Box className="styles-picker-container">
                  <Box className="colors-container">
                    <Box sx={{ display: "flex", gap: 2 }}>
                      {colors.map((color) => (
                        <Box
                          key={color}
                          onClick={() => handleColorClick(color)}
                          className="color"
                          sx={{
                            backgroundColor: color,
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                  <Slider
                    value={fontSize}
                    onChange={handleFontSizeChange}
                    min={10}
                    max={50}
                    step={1}
                    valueLabelDisplay="auto"
                    sx={{ width: "100px" }}
                  />
                </Box>
              </Box>
              <div className="final">
                <Typography>Your Logo demo</Typography>
                <div className="final-logo-container">
                  <Typography
                    sx={{
                      fontSize: `${fontSize}px`,
                      color: selectedColor,
                      fontFamily: selectedFont,
                    }}
                    className="final-logo"
                  >
                    {logoName || "LOREM"}
                  </Typography>
                </div>
              </div>
            </Box>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoSelect;
